enum HelpResource {
    Contributing = "Contributing",
    HowTo = "How To",
    Overview = "Overview",
}

export { HelpResource };
